import React from "react";

export default function () {
  return (
    <>
      <div className="card">
        {/*begin::Card body*/}
        <div className="card-body px-10 px-lg-20 pt-17 pb-10">
          This is home page

        </div>
        {/*end::Card body*/}
      </div>
    </>
  );
}